module.exports = __webpack_public_path__ + "static/media/wallfinishes_lcs_60yd_n.8e660197.csv";